module.exports = __webpack_public_path__ + "img/LTS_KPMG_KKK.7283c75d.gif";